import { render } from "./m-edit-card.vue?vue&type=template&id=2d124324"
import script from "./m-edit-card.vue?vue&type=script&lang=js"
export * from "./m-edit-card.vue?vue&type=script&lang=js"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__